export default "__VITE_ASSET__EfjIq3dr__"